"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zustand_1 = __importDefault(require("zustand"));
// Create the Zustand store with typed state and actions
const useStore = (0, zustand_1.default)((set) => ({
    count: 0,
    increaseCount: () => set((state) => ({ count: state.count + 1 })),
    resetCount: () => set({ count: 0 }),
}));
exports.default = useStore;
